import { useEffect, useState } from 'react';
import { castDice } from '../Game/Game';
import styled from 'styled-components';

interface IDice {
  diceNumber: number;
  move: string;
  activePlayer: number | null;
  selectedPlayer: number | null;
  stateChangeId: number | null;
}

const StyledDice = styled.img.attrs<{ diceImage: string }>((props) => ({
  src: props.diceImage,
  alt: 'Dice',
}))<{ diceImage: string }>`
  width: 65px;
  left: 285px;
  top: 295px;
  position: absolute;
`;

export default function Dice(props: IDice) {
  const [casting, setCasting] = useState(false);
  const { move, diceNumber, activePlayer, selectedPlayer, stateChangeId } =
    props;

  useEffect(() => {
    if (move === 'CAST') {
      setCasting(true);
      console.log('The dice has been cast.', diceNumber);
      setTimeout(function () {
        setCasting(false);
      }, 500);
    }
  }, [move, diceNumber, stateChangeId]);

  let diceImage = `./dice_casting_${activePlayer}.svg`;
  if (!casting) diceImage = `./dice_${props.diceNumber}.svg`;

  return (
    <StyledDice
      diceImage={diceImage}
      onClick={activePlayer === selectedPlayer ? castDice : undefined}
    />
  );
}
